module.exports = __webpack_public_path__ + "img/userLogo.74f12e1b.png";